import React, { useEffect, useState } from "react";
import { igemLogoDark, videos } from "../../../../../assets/icons";
import { VideoDialog } from "../../../../../components/VideoDialog/video-dialog";
import "./styles.scss";

interface SessionItemProps {
  item: {
    title: string;
    color: string;
   id: number;
   embedId: string;
   thumbnailId: string;
  };
 index: number;
}

export const SessionItem = (props: SessionItemProps): JSX.Element => {
  const { item,index } = props;
 const [open, setOpen] = useState<boolean>(false);
 const [thumbnail, setThumbnail] = useState<string>();

  useEffect(() => {
   import(`../../../../../assets/media/prevThumbnails/${item.thumbnailId}.jpg`)
     .then((image) => {
       // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
       setThumbnail(image.default);
       return true;
     })
     .catch(() => {
       setThumbnail(igemLogoDark);
     });
 }, []);
  return (
    <div className="si">
      <div className="si-header">
        <div className="si-header-line" />
        <div
          className="si-header-bubble"
          style={{
            backgroundColor: item.color,
            color: item.color === "#f8ed6e" ? "#191934" : "#f9fafb",
          }}
        >
          <p>{index}</p>
        </div>
      </div>
      <div className="si-body">
        <button type="button" onClick={() => setOpen(true)}>
          <div
            className="si-body-thumbnail"
            style={{ borderColor: item.color }}
      >
       <img src={thumbnail} alt={`thumbnail-${item.id}`}/>
            <div className="si-body-thumbnail-cover">
              <img src={videos} alt={`play-${item.id}`} />
            </div>
          </div>
        </button>
        <p className="si-body-title">{item.title}</p>
      </div>
      <VideoDialog
        open={open}
        setOpen={setOpen}
        title={item.title}
        videoId={item.embedId ?? ""}
      />
    </div>
  );
};
